import { useDataTableParamState } from "@/common/hooks/useDataTableParamState";
import { getDefaultColumnStates } from "@/common/utils/datatable";
import { GroupingColumn } from "@/feature/components/TableDisplayModePicker";
import { EntityFlagDTO } from "@reflag/shared/flagAPI";

export type UserFlagsColumn = keyof EntityFlagDTO;

export const groupingUserFlagsColumns = [
  { id: "value", label: "Access" },
  { id: "createdAt", label: "Created" },
] as const satisfies GroupingColumn<UserFlagsColumn>[];

const allowedGroupingColumns = groupingUserFlagsColumns.map((col) => col.id);

export const defaultUserFlagsColumns: UserFlagsColumn[] = [
  "name",
  "value",
  "firstExposureAt",
  "lastExposureAt",
  "lastCheckAt",
  "exposureCount",
  "createdAt",
];

export const useUserFlagsTableState = () =>
  useDataTableParamState<UserFlagsColumn, UserFlagsColumn>({
    sorting: [{ id: "createdAt", desc: true }],
    columnStates: getDefaultColumnStates(defaultUserFlagsColumns),
    groupingColumn: "value",
    allowedGroupingColumns,
  });
